import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";

class O {
}

class I {
  gatewayId!: number;
}

export class CancelAllDevicePendingConfigCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.CancelAllDevicePendingConfig);
    this.i = new I();
    this.o = new O();
  }
}
